import * as client_hooks from '../../../src/hooks.client.js';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/(protected)/(nav)/activities": [5,[2,3]],
		"/(protected)/(nav)/character-assets": [6,[2,3]],
		"/(public)/mobile": [13],
		"/(protected)/(nav)/shared": [7,[2,3]],
		"/(public)/signin": [14],
		"/(protected)/signout": [11,[2]],
		"/(protected)/(nav)/workspaces": [8,[2,3]],
		"/(protected)/(nav)/workspaces/[workspaceId]": [9,[2,3]],
		"/(protected)/(nav)/workspaces/[workspaceId]/folder/[folderId]": [10,[2,3]],
		"/(protected)/workspaces/[workspaceId]/project/[projectId]": [12,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';